import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthentication } from '../../modules/auth/AuthenticationProvider';
import { BACKEND_URL } from '../backend-url';

export const useRemoveGroupRepository = () => {
    const { getJwtToken } = useAuthentication();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (id: string) => {
            const token = await getJwtToken();

            const response = await fetch(`${BACKEND_URL}/groups/${id}`, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error('Failed to remove group');
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['groups'] });
        },
    });

    return {
        removeGroup: mutation.mutateAsync,
        ...mutation,
    };
};
